//flight stop filters
export const NON_STOP = 'non_stop';
export const ONE_STOP = '1_stop';
export const TWO_STOPS = '2_stops';

//Route line state
export const NORMAL_ROUTE = 1;
export const DIM_ROUTE = 2;
export const ACTIVE_ROUTE = 3;
export const THIN_ROUTE = 4;
export const HOVER_ROUTE = 5;